/*!
 * Copyright (c) 2026 GS Elektromedizinische Geraete G. Stemple GmbH, Germany - all rights reserved.
 * <p>
 * DO NOT ALTER OR REMOVE COPYRIGHT NOTICES OR THIS FILE HEADER.
 */

@use '../../../../variables';
@use '../../../../mixins';

#card-reanimation {
  .txt-other {
    margin-top: variables.$margin-small;
  }
}
